import { CloseCircle } from "iconsax-react";

export default function PaymentFailed() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-red-50 p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center">
        <div className="flex justify-center mb-6">
          <CloseCircle
            size="80"
            color="#ef4444"
            variant="Bold"
            className="animate-pulse"
          />
        </div>

        <h1 className="text-3xl font-bold text-red-700 mb-6 font-vazirmatn">
          پرداخت ناموفق بود
        </h1>

        <p className="text-gray-700 text-lg mb-8 leading-relaxed font-vazirmatn">
          متأسفانه پرداخت شما با مشکل مواجه شد. لطفاً دوباره تلاش کنید یا با
          پشتیبانی تماس بگیرید. ما آماده کمک به شما هستیم.
        </p>

        <div className="mt-8">
          <a
            href="/landing"
            className="px-6 py-3 bg-red-600 text-white rounded-lg font-medium hover:bg-red-700 transition-colors duration-300 font-vazirmatn"
          >
            تلاش مجدد
          </a>
        </div>
      </div>
    </div>
  );
}
